import React, { useState, useEffect } from "react";
import "../css/modal.css";
import { IoWarningOutline } from "react-icons/io5";
import BoletoService from "../../modules/services/BoletoService";
import EmailService from "../../modules/services/EmailService";

function ModalBoletoConfig({ isOpen, onClose, cliente, onClienteUpdate }) {
    const [emailBoleto, setEmailBoleto] = useState("");
    const [agree, setAgree] = useState(false);

    // Atualiza o email quando o modal abre ou quando o cliente muda
    useEffect(() => {
        if (isOpen && cliente) {
            // Busca o email da categoria 43 (BOLETO DIGITAL), mesmo que esteja desativado
            const emailExistente = cliente.emails.find(email => email.cdCategoriaEmail === 43)?.dsEmail || "";
            setEmailBoleto(emailExistente);
        }
    }, [isOpen, cliente]);

    if (!isOpen) return null;

    const handleSave = async () => {
        if (!agree) {
            alert("Você precisa concordar com os termos.");
            return;
        }

        if (!emailBoleto.trim()) {
            alert("Por favor, informe o email para o boleto digital.");
            return;
        }

        try {
            // Primeiro atualiza o email usando o EmailService
            await EmailService.atualizarEmails(cliente.cdCliente, {
                boleto: emailBoleto.trim(),
                nmResponsavel: cliente.razaoSocial,
            });
            
            // Depois ativa o boleto digital
            await BoletoService.configurarBoletoDigital(cliente.cdCliente, cliente.digitoCliente, true);
            
            alert("Boleto digital configurado com sucesso! A alteração pode demorar alguns instantes para ser processada.");
            
            if (onClienteUpdate) {
                await onClienteUpdate();
            }
            onClose();
        } catch (error) {
            alert("Erro ao configurar boleto digital.");
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <div className="topoModal">
                    <button className="modal-close" onClick={onClose}>✖</button>
                    <h3><b>Configurar Boleto Digital</b></h3>
                </div>
                <p>Para ativar o boleto digital, informe o email que receberá os boletos.</p>

                <label><b>Email para Boleto Digital</b></label>
                <input
                    type="email"
                    placeholder="Digite o email para receber os boletos"
                    value={emailBoleto}
                    onChange={(e) => setEmailBoleto(e.target.value)}
                />
 
                <p>O endereço eletrônico para envio do Boleto Digital é de responsabilidade do informante.</p>

                <div className="modal-checkbox">
                    <input type="checkbox" checked={agree} onChange={() => setAgree(!agree)} />
                    <label className="textoAceite">Estou ciente destas obrigações e concordo</label>
                </div>

                <div className="modal-actions">
                    <button className="cancel" onClick={onClose}>Cancelar</button>
                    <button 
                        className={`confirm ${!agree ? 'disabled' : ''}`} 
                        onClick={handleSave}
                        disabled={!agree}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ModalBoletoConfig; 